import React, { useEffect, forwardRef } from "react";
import { Link } from "react-router-dom";
import Rating from "./Rating";
import Pagination from "./pagination";
import { useDispatch, useSelector } from "react-redux";
import { listProduct } from "../../Redux/Actions/ProductActions";
import Loading from "../LoadingError/Loading";
import Message from "../LoadingError/Error";

// Forward ref to the ShopSection component
const ShopSection = forwardRef((props, ref) => {
  const { keyword, pagenumber } = props;
  const dispatch = useDispatch();

  const productList = useSelector((state) => state.productList);
  const { loading, error, products = [], page, pages } = productList;

  useEffect(() => {
    dispatch(listProduct(keyword, pagenumber));
  }, [dispatch, keyword, pagenumber]);

  return (
    <div ref={ref} className="shopsection-container">
      <div className="shop-intro">
        <h2>Explore the World in Color</h2>
        <p>
          Discover the magic of acrylic painting, where imagination bursts into vibrant color. Each piece tells 
          a unique story through bold brushstrokes and dynamic textures. Dive into a world of rich hues and 
          experience art that resonates with energy and emotion. Explore timeless creations crafted with 
          passion and creativity, capturing the essence of life on canvas.
        </p>
        <div className="prints-divider"></div>
      </div>

      <div className="shop-intro-section">
        <div className="shop-intro-image">
          <img src="/images/whiterhino.png" alt="Northern White Rhino" />
        </div>
        <div className="shop-intro-description col-md-5">
          <h2>The Beauty of Endangered Species: The Northern White Rhino</h2>
          <p>
            Through vibrant hues and delicate strokes, acrylic painting reveals the breathtaking beauty 
            of the critically endangered Northern White Rhino. With only two remaining, these majestic 
            creatures embody both life’s fragility and the power of conservation, capturing the rugged 
            texture of their skin and the soulful depth in their eyes.
          </p>
        </div>
      </div>

      <div className="shop-intro-section">
        <div className="shop-intro-description col-md-5">
          <h2>Bringing the Outdoors to Life</h2>
          <p>
            Dive into a world of creativity. Our gallery showcases diverse forms of art, from paintings and 
            sculptures to digital masterpieces. Our art collection connects stories and imagination.
          </p>
          <div className="view-gallery-button-container">
            
            <Link to="/prints">
              <button type="button" className="view-gallery-button">
                View Gallery
              </button>
            </Link>
          </div>
        </div>
        <div className="shop-intro-image2">
          <img src="/images/lionsinsavannah.png" alt="Lions in Savannah" />
        </div>
      </div>
      <hr />

      <div className="section-intro">
        <h1 className="intro-title">Discover Unique Art Pieces</h1>
        <p className="intro-text">
          Dive into a collection of breathtaking artworks that capture the essence of beauty, creativity, 
          and craftsmanship.
        </p>
      </div>

      <div className="section">
        <div className="row">
          <div className="col-lg-12 col-md-12 article">
            <div className="shopcontainer row">
              {loading ? (
                <div className="mb-5">
                  <Loading />
                </div>
              ) : error ? (
                <Message variant="alert-danger">{error}</Message>
              ) : (
                <>
                  {products.map((product) => (
                    <div
                      className="shop shop-container col-lg-4 col-md-6 col-sm-6"
                      key={product._id}
                    >
                      <div className="border-product">
                        <Link to={`/products/${product._id}`}>
                          <div className="shopBack">
                            <img src={product.image} alt={product.name} />
                          </div>
                        </Link>

                        <div className="shoptext">
                          <p>
                            <Link to={`/products/${product._id}`}>
                              {product.name}
                            </Link>
                          </p>

                          <Rating
                            value={product.rating}
                            // text={`${product.numReviews} reviews`}
                          />
                          {/* <h3>Ksh {product.price}</h3> */}
                        </div>
                      </div>
                    </div>
                  ))}
                </>
              )}

              {/* Pagination */}
              <Pagination
                pages={pages}
                page={page}
                keyword={keyword ? keyword : ""}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
});

export default ShopSection;
